// extracted by mini-css-extract-plugin
module.exports = {"item":"CommentCard_item_111B6"};